/* Solvaro · article VoluFine — 2 petites choses, rien de lourd :
   1) les boutons gardent les paramètres de l'adresse (utm…) de la page ;
   2) la barre d'achat collante apparaît après la part de lecture réglée (2/3 par défaut), puis reste. */
(function () {
  'use strict';

  function keepParams(root) {
    var qs = window.location.search;
    if (!qs || qs.length < 2) return;
    var links = root.querySelectorAll('a[data-sv-cta]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.getAttribute('data-sv-qs') === '1') continue;
      var href = a.getAttribute('href') || '';
      var hash = '';
      var h = href.indexOf('#');
      if (h > -1) { hash = href.slice(h); href = href.slice(0, h); }
      a.setAttribute('href', href + (href.indexOf('?') > -1 ? '&' : '?') + qs.slice(1) + hash);
      a.setAttribute('data-sv-qs', '1');
    }
  }

  function initSticky(root) {
    var bar = root.querySelector('[data-sv-sticky]');
    if (!bar || bar.getAttribute('data-sv-ready') === '1') return;
    bar.setAttribute('data-sv-ready', '1');
    var btn = bar.querySelector('a[data-sv-cta]');
    if (bar.hasAttribute('data-from-start')) { bar.classList.add('is-on'); bar.setAttribute('aria-hidden', 'false'); if (btn) btn.removeAttribute('tabindex'); return; } /* 17/10 : visible dès l'arrivée */
    var thr = parseFloat(bar.getAttribute('data-threshold'));
    if (!(thr > 0)) thr = 66;
    thr = thr / 100;
    var ticking = false;

    function show() {
      bar.classList.add('is-on');
      bar.setAttribute('aria-hidden', 'false');
      if (btn) btn.removeAttribute('tabindex');
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    }
    function check() {
      ticking = false;
      var doc = document.documentElement;
      var max = Math.max(doc.scrollHeight, document.body.scrollHeight) - window.innerHeight;
      var y = window.pageYOffset || doc.scrollTop || 0;
      if (max <= 0 || y / max >= thr) show();
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      setTimeout(check, 80);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    check();
  }

  function init() {
    var roots = document.querySelectorAll('.sv-vfa');
    for (var i = 0; i < roots.length; i++) {
      keepParams(roots[i]);
      initSticky(roots[i]);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
